import ServerError from './ServerError';

// --- Types ---

/**
 * Represents the structured error object used throughout the app.
 * We use 'any' for the 'error' property to handle raw responses.
 */
export interface AppError {
    type?: string;
    message?: string;
    [key: string]: any;
}

interface HandlerErrorParams {
    setError: (error: AppError) => void;
    setLoading: (isLoading: boolean) => void;
}

// --- Hook / Utility ---

/**
 * Returns a function to handle errors in a consistent way across hooks.
 * It automatically updates the error state and stops loading.
 */
const HandlerError = ({ setError, setLoading }: HandlerErrorParams) => (error: any): void => {
    if (typeof setError === 'function' && typeof setLoading === 'function') {
        // If the error doesn't have a 'type', it hasn't been processed yet,
        // so we wrap it in a ServerError.
        const errorToDispatch = error?.type !== undefined
            ? error
            : new ServerError(error);

        setError(errorToDispatch);
        setLoading(false);
    } else {
        console.error('HandlerError: setError and setLoading must be provided as functions.');
    }
};

export default HandlerError;
